module.exports = __webpack_public_path__ + "static/media/57-harkers.5677afc2.jpeg";